<template>
	<a-modal
		:visible="visible"
		:footer="null"
		:closable="false"
		:mask-closable="false"
		:destroy-on-close="true"
		width="560px"
		:centered="true"
		wrap-class-name="g-file-download-settings-modal"
		@cancel="onCancel"
	>
		<div class="g-edit-modal__scroll">
		<div class="g-file-download-settings">
			<div class="g-file-download-settings__header">
				<span class="g-file-download-settings__title">文件下载设置</span>
				<span
					class="g-file-download-settings__close mbm-iconfont mbm-guanbi1"
					@click="onCancel"
				></span>
			</div>

			<div class="g-file-download-settings__row">
				<div class="g-file-download-settings__label">全局设置</div>
				<div class="g-file-download-settings__content">
					<div class="g-file-download-settings__radios">
						<label
							class="g-file-download-settings__radio"
							:class="{ 'is-checked': form.global === FILE_DOWNLOAD_ALLOW }"
						>
							<input
								type="radio"
								:checked="form.global === FILE_DOWNLOAD_ALLOW"
								@change="form.global = FILE_DOWNLOAD_ALLOW"
							/>
							<span class="g-file-download-settings__radio-dot"></span>
							<span>允许下载</span>
						</label>
						<label
							class="g-file-download-settings__radio"
							:class="{ 'is-checked': form.global === FILE_DOWNLOAD_DENY }"
						>
							<input
								type="radio"
								:checked="form.global === FILE_DOWNLOAD_DENY"
								@change="form.global = FILE_DOWNLOAD_DENY"
							/>
							<span class="g-file-download-settings__radio-dot"></span>
							<span>关闭下载</span>
						</label>
					</div>
					<p class="g-file-download-settings__tips">所有二维码或链接内文件有效</p>
				</div>
			</div>

			<div class="g-file-download-settings__row">
				<div class="g-file-download-settings__label">独立设置</div>
				<div class="g-file-download-settings__content">
					<div class="g-file-download-settings__radios">
						<label
							class="g-file-download-settings__radio"
							:class="{ 'is-checked': form.independent === FILE_DOWNLOAD_ALLOW }"
							@click.prevent="toggleIndependent(FILE_DOWNLOAD_ALLOW)"
						>
							<span class="g-file-download-settings__radio-dot"></span>
							<span>允许下载</span>
						</label>
						<label
							class="g-file-download-settings__radio"
							:class="{ 'is-checked': form.independent === FILE_DOWNLOAD_DENY }"
							@click.prevent="toggleIndependent(FILE_DOWNLOAD_DENY)"
						>
							<span class="g-file-download-settings__radio-dot"></span>
							<span>关闭下载</span>
						</label>
					</div>
					<p class="g-file-download-settings__tips">当前二维码内文件有效</p>
				</div>
			</div>

			<p class="g-file-download-settings__notice">
				全局设置不会改变独立设置，独立设置保持最高优先级，如无特殊需要，不要使用独立设置
			</p>

			<div class="g-file-download-settings__footer">
				<button type="button" class="g-file-download-settings__btn is-cancel" @click="onCancel">
					取消
				</button>
				<button type="button" class="g-file-download-settings__btn is-confirm" @click="onConfirm">
					确认
				</button>
			</div>
		</div>
		</div>
	</a-modal>
</template>

<script>
	import {
		FILE_DOWNLOAD_ALLOW,
		FILE_DOWNLOAD_DENY,
		FILE_DOWNLOAD_INDEPENDENT_NONE,
		normalizeFileDownloadSettings,
	} from '../utils/localFile.js';

	export default {
		name: 'GFileDownloadSettingsModal',
		props: {
			visible: {
				type: Boolean,
				default: false,
			},
			value: {
				type: Object,
				default: () => ({}),
			},
		},
		emits: ['update:visible', 'confirm'],
		data() {
			return {
				FILE_DOWNLOAD_ALLOW,
				FILE_DOWNLOAD_DENY,
				form: normalizeFileDownloadSettings(),
			};
		},
		watch: {
			visible(value) {
				if (value) {
					this.form = { ...normalizeFileDownloadSettings(this.value) };
				}
			},
		},
		methods: {
			toggleIndependent(value) {
				this.form.independent = this.form.independent === value
					? FILE_DOWNLOAD_INDEPENDENT_NONE
					: value;
			},
			onCancel() {
				this.$emit('update:visible', false);
			},
			onConfirm() {
				this.$emit('confirm', normalizeFileDownloadSettings(this.form));
				this.$emit('update:visible', false);
			},
		},
	};
</script>

<style scoped lang="less">
	.g-file-download-settings__header {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-bottom: 24px;
	}

	.g-file-download-settings__title {
		font-size: 16px;
		font-weight: 600;
		color: #333;
	}

	.g-file-download-settings__close {
		font-size: 16px;
		color: #999;
		cursor: pointer;
		line-height: 1;

		&:hover {
			color: #666;
		}
	}

	.g-file-download-settings__row {
		display: flex;
		align-items: flex-start;
		gap: 16px;
		margin-bottom: 20px;
	}

	.g-file-download-settings__label {
		width: 72px;
		flex-shrink: 0;
		font-size: 14px;
		font-weight: 600;
		color: #333;
		line-height: 32px;
	}

	.g-file-download-settings__content {
		flex: 1;
		min-width: 0;
	}

	.g-file-download-settings__radios {
		display: flex;
		align-items: center;
		gap: 24px;
		flex-wrap: wrap;
	}

	.g-file-download-settings__radio {
		display: inline-flex;
		align-items: center;
		gap: 6px;
		font-size: 14px;
		color: #666;
		cursor: pointer;
		user-select: none;

		input {
			position: absolute;
			opacity: 0;
			pointer-events: none;
		}

		&.is-checked {
			color: #333;

			.g-file-download-settings__radio-dot {
				border-color: #285af9;

				&::after {
					opacity: 1;
				}
			}
		}
	}

	.g-file-download-settings__radio-dot {
		position: relative;
		width: 14px;
		height: 14px;
		border: 1px solid #d9d9d9;
		border-radius: 50%;
		box-sizing: border-box;

		&::after {
			content: '';
			position: absolute;
			top: 50%;
			left: 50%;
			width: 8px;
			height: 8px;
			margin: -4px 0 0 -4px;
			border-radius: 50%;
			background: #285af9;
			opacity: 0;
		}
	}

	.g-file-download-settings__tips {
		margin: 8px 0 0;
		font-size: 12px;
		color: #999;
		line-height: 1.5;
	}

	.g-file-download-settings__notice {
		margin: 8px 0 24px;
		font-size: 12px;
		color: #ff8a44;
		line-height: 1.6;
	}

	.g-file-download-settings__footer {
		display: flex;
		justify-content: flex-end;
		gap: 10px;
	}

	.g-file-download-settings__btn {
		min-width: 72px;
		height: 32px;
		padding: 0 16px;
		border-radius: 4px;
		font-size: 14px;
		cursor: pointer;
		outline: none;

		&.is-cancel {
			border: 1px solid #d9d9d9;
			background: #fff;
			color: #333;

			&:hover {
				color: #5280ff;
    			border-color: #5280ff;
			}
		}

		&.is-confirm {
			border: none;
			background: #285af9;
			color: #fff;

			&:hover {
				background: #3868ff;
			}
		}
	}
</style>

<style lang="less">
	@import '../styles/edit-float-panel.less';

	.g-file-download-settings-modal {
		.edit-modal-scroll();

		.ant-modal-body {
			padding: 20px 24px 18px;
		}
	}
</style>
